import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 7.486a.7.7 0 0 1 .7-.7h12.814a.7.7 0 0 1 .7.7V20.3a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V7.486Zm1.4.7V19.6h11.414V8.186H4.4Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5.621 3.7a.7.7 0 0 1 .7-.7H20.3a.7.7 0 0 1 .7.7v13.979a.7.7 0 0 1-.7.7h-3.316a.7.7 0 1 1 0-1.4H19.6V4.4H7.021v2.212a.7.7 0 1 1-1.4 0V3.7Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.977 16.555c-4.434-1.662-9.21-.578-11.444.52a.7.7 0 1 1-.618-1.256c2.485-1.221 7.669-2.406 12.554-.574a.7.7 0 1 1-.492 1.31Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M8.485 11.386a1.024 1.024 0 1 1-2.047 0 1.024 1.024 0 0 1 2.047 0Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
